<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>
            Aquisição da unidade em Barra do Garças (MT) e início dos pilares do
            sistema de gestão da JBS
          </h2>
          <p>
            Foi nessa unidade de Barra de Garças (MT)
            <strong>que nasceram</strong> os pilares do sistema de gestão da
            JBS. A implantação dessas ferramentas aprimorou a capacidade da
            empresa para operar suas fábricas distribuídas por todo o Brasil.
          </p>
          <img
            src="../assets/img/1997/1997-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/1997/1997-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1989/05/21/g/19890521-35046-nac-0078-eco-14-not-wwpkhqs.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/1997/1997-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1994/03/14/g/19940314-36671-nac-0030-eco-b4-not-aqeapkk.jpg'
              )
            "
            class="secondItem"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2><i>Diet</i>, <i>light</i> e preocupação saudável</h2>
          <p>
            Ao mesmo tempo que crescia a busca por opções rápidas de
            alimentação, muita gente passou a buscar alternativas para evitar o
            sobrepeso e a obesidade. Nos anos 1990, um dos primeiros chamarizes
            desse movimento foi o surgimento de alimentos
            <strong>light e diet</strong>, que traziam menor carga de gorduras e
            substituição de açúcares por adoçantes, atendendo não só quem queria
            se manter em forma, mas também incluindo novos produtos na mesa de
            quem sofria com a diabetes.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/1997/1997-1-full.jpg"),
          title:
            "1997 - Aquisição da unidade em Barra do Garças (MT), da Sadia, onde nasceram os pilares do sistema de gestão da JBS",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 515px 300px 260px;
    gap: 10px;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 20px;
      }
      &--image {
        position: relative;
        @include media("<=desktop") {
          padding: 20px;
        }
        span {
          position: absolute;
          left: 0px;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          @include media("<=desktop") {
            position: initial;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media("<=desktop") {
          padding: 20px;
          background: color(cGreen);
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cGreen);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
